import { put, select, takeLatest } from "redux-saga/effects";
import requestWrapper from "utils/requestWrapper";
import {
  LOAD_ABSENCES,
  CHANGE_ABSENCES,
  DELETE_ABSENCE,
} from "./constants";

import {
  // list
  loadAbsencesError,
  loadAbsencesSuccess,
  changeAbsencesSuccess,
  changeAbsencesError,
  // one
  deleteAbsenceSuccess,
  deleteAbsenceError,
} from "./actions";

import { notification } from "antd";

// utils
import api from "utils/api";
const { endpoint } = api;
import { getObjId } from "utils/helpers/helper.general";
import _local from "utils/localStorageUtils";

export function* loadAbsences() {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();
    const { role } = currentUser;

    // we get the campaigns linked to the absences
    const itemsList = yield requestWrapper(
      "GET",
      role == "teacher" ? endpoint?.absences?.teacher?.list(getObjId(currentUser)) : `absence/list`,
      "",
      currentUser.token,
    );

    if (!itemsList && !itemsList?.data) {
      yield put(loadAbsencesSuccess(false));
    } else {
      const firstElem = itemsList.data[0];
      yield put(loadAbsencesSuccess(itemsList, firstElem));
    }
  } catch (error) {
    yield put(loadAbsencesError(error));
  }
}

export function* changeAbsences(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();
    const { list } = action;

    let updatedList = false;

    updatedList = yield requestWrapper(
      "PATCH",
      endpoint?.absences?.updateStatus,
      list,
      currentUser.token,
    );
    notification.success({ message: "Mis à jour" });

    if (!updatedList) {
      yield put(changeAbsencesSuccess(false));
    } else {
      yield put(changeAbsencesSuccess(updatedList));
    }
  } catch (error) {
    yield put(changeAbsencesError(error));
  }
}

export function* deleteAbsence(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();
    const { id } = action;

    const deleteAbsence = yield requestWrapper(
      "PATCH",
      endpoint?.absences?.archive,
      {
        _id: id,
      },
      currentUser.token,
    );

    if (deleteAbsence) {
      yield put(deleteAbsenceSuccess());
    }
  } catch (error) {
    yield put(deleteAbsenceError(error));
  }
}

export default function* absenceSaga() {
  // list
  yield takeLatest(LOAD_ABSENCES, loadAbsences);
  yield takeLatest(CHANGE_ABSENCES, changeAbsences);
  yield takeLatest(DELETE_ABSENCE, deleteAbsence);
}
